import { useApiMutationAdminSearchOrdersByCampaignWithOrderHash } from '@hooks-api/fortune-fastpass/use-api-admin-search-orders-by-campaign'
import { type CampaignAdminErrorResponse } from '@hooks-api/types/apiErrorResponse'
import { FastpassOrderStatus } from '@hooks-api/types/dataModel/fpOrder'
import { ErrorFilled } from '@pets-ui/icons'
import { useSnackbar } from '@pets-ui/Snackbar/useSnackbar'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { AxiosError } from 'axios'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom-v5'
import { getClient } from '../../clients'
import AdminHeader from '../../components/admin-header'
import FixedFooter from '../../components/fixed-footer'
import { Camera } from '../../components/icon'
import QRCodeScanner from '../../components/qrcode-scanner'
import { useCampaign } from '../../hooks/use-campaign'
import { OrderModel } from '../../model/order-model'
import { setOrder } from '../../store/reducer/admin-reducer'
import style from '../../style/pages/admin-scan.module.scss'

const AdminScan = () => {
  const { campaignCodeFromUrl } = useCampaign()
  const { campaignID } = useParams<{ campaignID: string }>()
  const history = useHistory()
  const { t } = useTranslation()
  const [QRcode, setQRcode] = useState<string | null>(null)
  const [isOpen, setIsOpen] = useState(false)
  const dispatch = useDispatch()
  const adminToken = JSON.parse(sessionStorage.getItem('admin') || '{}')
  const { trigger } = useApiMutationAdminSearchOrdersByCampaignWithOrderHash()
  const { openSnackbar } = useSnackbar()
  const toggleCamera = () => setIsOpen(state => !state)

  useEffect(() => {
    const getOrder = async () => {
      if (!QRcode) {
        return
      }
      try {
        const { data } = await trigger({ order_hash: QRcode, code: campaignID })

        dispatch(setOrder(data.data))
        const orderModel = new OrderModel(data.data)
        const isOrderCompleted = orderModel.order.status === FastpassOrderStatus.COMPLETED
        const isConfirmedGiveaway = orderModel.order.item_confirmed

        if (isOrderCompleted) {
          if (!isConfirmedGiveaway) {
            history.push(`/admin/${campaignCodeFromUrl}/admin-order-check/${data.data.id}`)
            return
          }
          else {
            history.push(`/admin/${campaignCodeFromUrl}/admin-checked`)
            return
          }
        }
        history.push(`/admin/${campaignCodeFromUrl}/admin-review/${data.data.id}`)
      }
      catch (error) {
        if (error instanceof AxiosError) {
          const errorData = error.response?.data as CampaignAdminErrorResponse
          if (errorData.error.code === 5600) {
            openSnackbar({
              message: '憑證過期，請重新登入！',
              anchorOrigin: { horizontal: 'center', vertical: 'top' },
              icon: <ErrorFilled color={colors.red600} />,
            })
            sessionStorage.removeItem('admin')
            getClient('fastpassAdmin').defaults.headers['admin-access-token'] = ''
            history.push(`/admin/${campaignCodeFromUrl}/admin-login`)
          }
        }
      }
    }

    getOrder()
  }, [QRcode, campaignCodeFromUrl, campaignID, dispatch, history, openSnackbar, trigger])

  const HelloPage = () => (
    <>
      <h1 className={style.hello}>
        Hi！
        {adminToken?.name || ''}
      </h1>
      <button className="icon-button" onClick={() => setIsOpen(true)}>
        <Camera />
      </button>
    </>
  )

  const ScanPage = () => (
    <>
      <h3 className={style['scan-message']}>{t('qrcode.scan')}</h3>
      <QRCodeScanner className={style.scanner} setQRcode={url => setQRcode(url)} />
    </>
  )

  return (
    <main className={style.main + (isOpen ? ` ${style.active}` : '')}>
      <AdminHeader />
      {isOpen ? <ScanPage /> : <HelloPage />}
      <FixedFooter>
        <button
          className={style['toggle-button'] + (isOpen ? ` ${style.active}` : '')}
          onClick={toggleCamera}
        >
          {isOpen ? t('qrcode.cancel') : t('qrcode.openCamera')}
        </button>
      </FixedFooter>
    </main>
  )
}

export default AdminScan
